import {AxiosResponse} from 'axios';
import {ClientRole, Customer, UserAddress, createAddress} from 'types';
import {ApiClient} from './api-client';
import {omit, pick} from 'lodash';
import {Request} from 'types';

export type UpdateCustomerDto = {
  first_name?: string;
  last_name?: string;
  email?: string;
  birthday?: string | Date;
  phone?: string;
  phone_2?: string;
  phone_3?: string;
  addresses?: UserAddress[];
  requests?: Request[];
  avatar?: null | string;
  customer_company?: string;
  client_role?: ClientRole;
};

export class CustomerService extends ApiClient {
  public async update(
    customerId: number,
    userId: number,
    dto: UpdateCustomerDto
  ): Promise<AxiosResponse<Customer>> {
    const customerBody = pick(dto, ['allergies', 'birthday', 'client_role']);
    if (dto.phone_2) {
      customerBody.phone_2 = dto.phone_2;
    }
    if (dto.phone_3) {
      customerBody.phone_3 = dto.phone_3;
    }
    if (dto.customer_company) {
      customerBody.customer_company = dto.customer_company;
    }
    if (dto.email) {
      customerBody.email = dto.email;
    }
    if(process.env.NODE_ENV === 'development') {
      console.log(omit(dto, 'birthday'));
    }
    await this.patch(`/users/${userId}/`, omit(dto, 'birthday'));
    await this.patch(`/customers/${customerId}/`, customerBody);

    if (dto.addresses) {
      await Promise.all(
        (dto.addresses || []).map((address) =>
          this.patch(
            `/customers/address/${address.id}/`,
            omit(address, 'id', 'type', 'is_valid')
          )
        )
      );
    }

    return await this.get(`/customers/${customerId}/`);
  }

  public async createAddress(
    newAddress: createAddress,
    customerId: number
  ): Promise<AxiosResponse<Customer>> {
    return await this.post(`/customers/address/`, newAddress);
  }

  public async sendNotification(
    requestId: number,
    request_drugs: Array<any>,
    types: any
  ): Promise<any> {
    return this.post(`/requests/${requestId}/notify-customer/`, {
      request_drugs,
      ...types,
    });
  }
  public async updateDeliveryAddress(
    requestId: number,
    addressId: any
  ): Promise<any> {
    return this.post(`/requests/${requestId}/change_delivery_address/`, {
      delivery_address_id: addressId,
    });
  }

  public async requestSignature(requestId: number): Promise<any> {
    return this.get(`/requests/${requestId}/request_signature/`);
  }
}
